import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-text-meta',
    templateUrl: './text-meta.component.html',
    styleUrls: ['./text-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('text-meta')
export class TextMetaComponent {
    model = input<any>();

    metaPattern: any = { id: 'pattern', name: 'Pattern' };
    metaMaxLength: any = { id: 'maxLength', name: 'Max Length', min: 1 };
}
